export enum ContextActionTypes {
  CALC_MATCH_RESULT = 'CALC_MATCH_RESULT'
}

export enum ContextMutationTypes {
  MATCH_RESULT_LOADING = 'MATCH_RESULT_LOADING',
  SET_MATCH_RESULT = 'SET_MATCH_RESULT'
}